import { StyledIcon } from './index.style'

interface ICloseProps {
  bgColor?: string
  bgOpacity?: number
}

export const Close = ({ bgColor = 'black', bgOpacity = 0.4 }: ICloseProps) => {
  return (
    <StyledIcon
      viewBox='0 0 30 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        width='30'
        height='30'
        rx='15'
        fill={bgColor}
        fillOpacity={bgOpacity}
      />
      <path
        d='M20.175 20.5539L14.775 15.1539M14.775 15.1539L9.375 9.75391M14.775 15.1539L20.175 9.75391M14.775 15.1539L9.375 20.5539'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </StyledIcon>
  )
}
